import React from 'react';
import { Lock } from 'lucide-react';
import { useFormikContext } from 'formik';
import type { LinkInBio } from '@repo/lib';
import isPayingSeller from '@repo/checkout/lib/isPayingSeller';
import shouldShowLinkInBioBranding from '@repo/checkout/lib/linkInBio/shouldShowLinkInBioBranding';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import CanUseFeature from '@dashboard/components/CanUseFeature';
import { Label } from '@dashboard/components/ui/label';
import { Switch } from '@dashboard/components/ui/switch';
import Features from '@dashboard/enums/features';

const LABEL = 'Powered by Checkout Page branding';

export default function BrandingToggle() {
  const { seller } = useAuth();
  const { values, setFieldValue } = useFormikContext<LinkInBio>();

  if (!isPayingSeller(seller)) {
    return (
      <CanUseFeature
        feature={Features.CHECKOUT_PAGE_BADGE}
        isDisabled
        showIcon={false}
        reduceOpacity={false}
        description={
          seller.subscriptionStatus === 'trialing'
            ? 'Checkout Page branding is shown during your trial. Upgrade to a paid plan to remove it from your link in bio.'
            : 'The Free plan always shows Checkout Page branding. Upgrade to a paid plan to remove it from your link in bio.'
        }
      >
        <div className="flex items-center justify-between gap-4">
          <span className="text-sm font-medium text-muted-foreground">{LABEL}</span>
          <Lock className="size-4 shrink-0 text-muted-foreground" aria-label="Upgrade to change" />
        </div>
      </CanUseFeature>
    );
  }

  return (
    <div className="flex items-center justify-between gap-4">
      <Label htmlFor="link-in-bio-branding">{LABEL}</Label>
      <Switch
        id="link-in-bio-branding"
        checked={shouldShowLinkInBioBranding(seller, values)}
        onCheckedChange={checked => setFieldValue('showCheckoutPageBranding', checked)}
      />
    </div>
  );
}
